<template>
  <div class="user-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewDataLocal"
        class="modern-modal__overlay"
        @click.self="closeForm">
        <div class="modern-modal modern-modal--md">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p v-if="editMode" class="modern-modal__subtitle">
                Update user details below, then select Update to save changes.
              </p>
              <p v-else class="modern-modal__subtitle">
                Fill in the form to add a new user to your fleet management team.
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="closeForm">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <form class="modal-form" @submit.prevent>
                <div class="modal-columns">
                  <div class="modal-column">
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Name<sup>*</sup></label>
                      <div class="vs-con-input">
                        <input
                          type="text"
                          v-model="name"
                          name="name"
                          class="vs-inputx vs-input--input normal" />
                      </div>
                      <span></span>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Email<sup>*</sup></label>
                      <div class="vs-con-input">
                        <input
                          type="email"
                          v-model="email"
                          name="email"
                          class="vs-inputx vs-input--input normal" />
                      </div>
                      <span></span>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Phone Number<sup>*</sup></label>
                      <div class="vs-con-input">
                        <input
                          type="number"
                          v-model="no_telp"
                          name="no_telp"
                          class="vs-inputx vs-input--input normal" />
                      </div>
                      <span></span>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">New Password<sup>*</sup></label>
                      <div class="vs-con-input">
                        <input
                          autocomplete="new_password"
                          placeholder="Leave empty if not changing"
                          type="password"
                          v-model="new_password"
                          name="new_password"
                          class="vs-inputx vs-input--input normal"
                          onfocus="this.removeAttribute('readonly');"
                          readonly />
                      </div>
                      <span></span>
                    </div>
                  </div>

                  <div class="modal-column">
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Role<sup>*</sup></label>
                      <v-select
                        style="background: white"
                        @input="(x) => (role_id = x.value)"
                        :clearable="false"
                        :value="getSelectValue(role_id, roleData)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="roleData" />
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Fleet Group(s)</label>
                      <div class="field-group__multiselect">
                        <vs-select
                          placeholder="Search and select"
                          class="selectExample w-full"
                          label="Fleet Group(s)"
                          label-placeholder="Fleet Group(s)"
                          multiple
                          autocomplete
                          v-model="fleet_group_id">
                          <div class="field-inline field-inline--action-group">
                            <vs-button class="w-full mb-1" size="small" @click="selectAllFleet">
                              Select All
                            </vs-button>
                            <vs-button
                              class="w-full mb-1"
                              color="danger"
                              size="small"
                              @click="deselectAllFleet">
                              Deselect All
                            </vs-button>
                          </div>
                          <vs-select-item
                            :key="index"
                            :value="item.value"
                            :text="item.text"
                            v-for="(item, index) in fleetData" />
                        </vs-select>
                      </div>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Status<sup>*</sup></label>
                      <v-select
                        style="background: white"
                        @input="(x) => (is_active = x.value)"
                        :clearable="false"
                        :value="getSelectValue(is_active, active_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="active_array" />
                    </div>
                  </div>
                </div>

                <div class="modal-section">
                  <h4 class="modal-section__title">Notification Settings</h4>
                  <p class="modal-section__hint">
                    Choose which alerts this user may receive, then enable the delivery
                    channels.
                  </p>

                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                    <label class="vs-input--label">Alert Type(s)</label>
                    <div class="field-group__multiselect">
                      <vs-select
                        placeholder="Search and select"
                        class="selectExample w-full"
                        label="Alert Type(s)"
                        label-placeholder="Alert Type(s)"
                        multiple
                        autocomplete
                        v-model="alert_types">
                        <div class="field-inline field-inline--action-group">
                          <vs-button class="w-full mb-1" size="small" @click="selectAllAlert">
                            Select All
                          </vs-button>
                          <vs-button
                            class="w-full mb-1"
                            color="danger"
                            size="small"
                            @click="deselectAllAlert">
                            Deselect All
                          </vs-button>
                        </div>
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item, index) in alertData" />
                      </vs-select>
                    </div>
                  </div>

                  <div class="modal-columns mb-6">
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">WhatsApp Notification</label>
                      <div class="field-inline field-inline--radio">
                        <vs-radio
                          v-for="(item, index) in notif_status_array"
                          :key="index"
                          vs-name="notif_whatsapp"
                          v-model="notif_whatsapp"
                          :vs-value="item.value">
                          {{ item.text }}
                        </vs-radio>
                      </div>
                    </div>

                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Email Notification</label>
                      <div class="field-inline field-inline--radio">
                        <vs-radio
                          v-for="(item, index) in notif_status_array"
                          :key="index"
                          vs-name="notif_email"
                          v-model="notif_email"
                          :vs-value="item.value">
                          {{ item.text }}
                        </vs-radio>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button
              class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
              @click="submitForm"
              v-if="!editMode">
              Submit
            </vs-button>
            <vs-button
              class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
              @click="updateForm"
              v-if="editMode">
              Update
            </vs-button>
            <vs-button
              color="danger"
              class="mr-3 mb-2 btn-load-3 vs-con-loading__container"
              @click="deleteData"
              v-if="editMode">
              Delete
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="closeForm">
              Cancel
            </vs-button>
            <vs-button
              class="mr-3 mb-2 btn-load-4 vs-con-loading__container"
              @click="resendActivation"
              v-if="editMode && dataEdit.is_active == 0">
              Resend Activation
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as REPO from '../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    roleData: Array,
    fleetData: Array,
    alertData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  data() {
    return {
      fleet_array: [],
      active_array: [
        {
          text: 'Active',
          value: 1,
        },
        {
          text: 'Inactive',
          value: 0,
        },
      ],
      role_array: [],
      name: '',
      new_password: '',
      role_id: '',
      is_active: 1,
      fleet_group_id: [],
      email: '',
      no_telp: '',
      is_selected: false,
      alert_types: [],
      notif_whatsapp: 0,
      notif_email: 0,
      notif_status_array: [
        {
          text: 'Active',
          value: 1,
        },
        {
          text: 'Inactive',
          value: 0,
        },
      ],
    }
  },
  watch: {
    name(val) {
      this.name = val.toUpperCase()
    },
    // fleet_group_id(val) {
    //   console.log('fgid', val)
    // },
    // is_selected(val) {
    //   console.log('is_selected', val)
    // },
    editMode(val) {
      if (val) {
        this.fillFromDataEdit()
      } else {
        //
      }
    },
  },
  mounted() {},
  computed: {
    addNewDataLocal: {
      get() {
        let isOpen = false
        if (typeof this.addNewData === 'string') {
          const normalized = this.addNewData.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(this.addNewData)
            } catch (e) {
              isOpen = !!this.addNewData
            }
          }
        } else {
          isOpen = !!this.addNewData
        }

        if (isOpen) {
          if (this.editMode) {
            this.fillFromDataEdit()
          } else {
            this.clearFields()
          }
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  methods: {
    fillFromDataEdit() {
      this.name = this.dataEdit.name
      this.email = this.dataEdit.email
      this.no_telp = this.dataEdit.no_telp
      this.role_id = this.dataEdit.role_id
      let fgid = []
      try {
        if (this.dataEdit.fleet_group_ids) {
          fgid = JSON.parse(this.dataEdit.fleet_group_ids) || []
        }
      } catch (e) {
        fgid = []
      }
      this.fleet_group_id = fgid
      this.is_active = this.dataEdit.is_active

      // notification settings (null kalau user belum punya row MsUserNotification)
      const notif = this.dataEdit.notification || {}
      let types = notif.alert_types || []
      if (typeof types === 'string') {
        try {
          types = JSON.parse(types) || []
        } catch (e) {
          types = []
        }
      }
      this.alert_types = Array.isArray(types) ? types : []
      this.notif_whatsapp = Number(notif.whatsapp) === 1 ? 1 : 0
      this.notif_email = Number(notif.email) === 1 ? 1 : 0
    },
    selectAllFleet() {
      this.fleet_group_id = this.fleetData.map((x) => x.value)
    },
    deselectAllFleet() {
      this.fleet_group_id = []
    },
    selectAllAlert() {
      this.alert_types = this.alertData.map((x) => x.value)
    },
    deselectAllAlert() {
      this.alert_types = []
    },
    resendActivation() {
      this.loadingBtnStart('btn-load-4')
      REPO.resendActivation(this.dataEdit.id)
          .then((res) => {
            if (res.data.status == 'true') {
              this.$toast.success('Email Successfully Sent')
            } else {
              throw { message: res.data.error_msg }
            }

            this.loadingBtnStop('btn-load-4')
          })
          .catch((err) => {
            //
            this.$toast.error(err.message)
            this.loadingBtnStop('btn-load-4')
          })
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.name = ''
      this.email = ''
      this.no_telp = ''
      this.role_id = ''
      this.new_password = ''
      this.fleet_group_id = []
      this.is_active = 1
      this.alert_types = []
      this.notif_whatsapp = 0
      this.notif_email = 0
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        name: this.name,
        email: this.email,
        no_telp: this.no_telp,
        role_id: this.role_id,
        password: this.new_password,
        fleet_group_ids: this.fleet_group_id,
        is_active: this.is_active,
        created_by: this.$dataLocal.UserData().name,
        notification: {
          alert_types: this.alert_types,
          whatsapp: this.notif_whatsapp,
          email: this.notif_email,
        },
      }
      REPO.postUser(dataForm)
          .then((res) => {
            this.loadingBtnStop('btn-load-1')
            if (res.data.status == 'true') {
              this.clearFields()

              this.$emit('submitModal', false)
              this.$toast.success('Data Successfullly Submitted')
            } else {
              throw { message: res.data.error_msg }
            }
          })
          .catch((err) => {
            this.loadingBtnStop('btn-load-1')
            //
            this.$toast.error(err.message)
          })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteUser(this.dataEdit.id)
          .then((res) => {
            this.clearFields()
            this.loadingBtnStop('btn-load-3')
            this.$emit('submitModal', false)
            this.$toast.error('Data Successfully Deleted')
          })
          .catch((err) => {
            //
            this.loadingBtnStop('btn-load-3')
            this.$toast.error(err.message)
          })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        name: this.name,
        email: this.email,
        no_telp: this.no_telp,
        role_id: this.role_id,
        fleet_group_ids: this.fleet_group_id,
        is_active: this.is_active,
        updated_by: this.$dataLocal.UserData().name,
        notification: {
          alert_types: this.alert_types,
          whatsapp: this.notif_whatsapp,
          email: this.notif_email,
        },
      }
      if (this.new_password !== '') {
        dataForm.password = this.new_password
      }

      REPO.updateUser(dataForm, this.dataEdit.id)
          .then((res) => {
            this.clearFields()
            this.loadingBtnStop('btn-load-2')
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfully Submitted')
          })
          .catch((err) => {
            //
            this.loadingBtnStop('btn-load-2')
            this.$toast.error(err.message)
          })
    },
  },
}
</script>

<style>
sup {
  color: red;
}

#content-area.content-area-default .user-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .user-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .user-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced) .user-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .user-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>

<style scoped>
.user-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(820px, 96vw);
  max-height: 84vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 26px 32px 18px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #64748b;
  max-width: 520px;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 28px;
  overflow: hidden;
}

.modern-modal__scroll {
  max-height: calc(84vh - 180px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__scroll::-webkit-scrollbar {
  width: 6px;
}

.modern-modal__scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 9999px;
}

.modern-modal__scroll::-webkit-scrollbar-track {
  background: transparent;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 32px 28px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.modal-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 24px;
}

.modal-column {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field-group--stacked {
  white-space: normal;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group:focus-within {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: 0.01em;
}

.field-group span {
  display: none;
}

.field-group .vs-con-input {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field-group .vs-con-input:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-inputx.vs-input--input.normal {
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 0.94rem;
  line-height: 1.5;
  color: #0f172a;
}

.field-group .vs-inputx.vs-input--input.normal:focus {
  box-shadow: none;
}

.field-group .vs-inputx.vs-input--input.normal[readonly] {
  cursor: text;
}

.field-group ::v-deep(.vs__dropdown-toggle) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  padding: 6px 14px;
  min-height: 44px;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.field-group ::v-deep(.vs__dropdown-toggle:focus),
.field-group ::v-deep(.vs__dropdown-toggle.vs__dropdown-toggle--focus) {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group ::v-deep(.vs__selected-options) {
  flex-wrap: wrap;
  gap: 6px;
}

.field-group ::v-deep(.vs__dropdown-menu) {
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
  margin-top: 6px;
}

.field-group ::v-deep(.vs__search) {
  padding: 0;
  margin: 0;
}

.field-group__multiselect ::v-deep(.vs-select--multiple .vs__selected) {
  margin: 4px;
}

.field-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.field-inline--action-group {
  margin-bottom: 12px;
}

.field-inline--radio {
  gap: 24px;
  padding: 6px 2px 4px;
  flex-wrap: wrap;
}

.modal-section {
  margin-top: 6px;
  padding-top: 18px;
  border-top: 1px solid #e2e8f0;
}

.modal-section__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modal-section__hint {
  margin: 4px 0 14px;
  font-size: 0.82rem;
  line-height: 1.4;
  color: #64748b;
}

.modal-section .field-group {
  margin-bottom: 0;
}

.modal-section > .field-group {
  margin-bottom: 18px;
}

.modern-modal ::v-deep(.vs-button) {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .modal-columns {
    grid-template-columns: 1fr;
  }

  .modern-modal {
    width: min(720px, 96vw);
  }
}

@media (max-width: 768px) {
  .modern-modal {
    width: min(680px, 96vw);
  }

  .modern-modal__header,
  .modern-modal__body,
  .modern-modal__footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 640px) {
  .modern-modal__header {
    flex-direction: column;
    align-items: stretch;
  }

  .modern-modal__close {
    align-self: flex-end;
  }

  .modern-modal {
    width: min(600px, 94vw);
  }
}
</style>
